module.exports = __webpack_public_path__ + "img/room_empty_icon.4a974efc.svg";